import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface LayoutState {
	isSidebarOpen: boolean
	isRightSidebarOpen: boolean
	isChatStreaming: boolean
}

const initialState: LayoutState = {
	isSidebarOpen: true,
	isRightSidebarOpen: true,
	isChatStreaming: false
}

const layoutSlice = createSlice({
	name: 'layout',
	initialState,
	reducers: {
		setIsSidebarOpen(state, action: PayloadAction<boolean>) {
			state.isSidebarOpen = action.payload
		},
		setIsRightSidebarOpen(state, action: PayloadAction<boolean>) {
			state.isRightSidebarOpen = action.payload
		},
		setIsChatStreaming(state, action: PayloadAction<boolean>) {
			state.isChatStreaming = action.payload
		}
	}
})

export const { setIsSidebarOpen, setIsRightSidebarOpen, setIsChatStreaming } = layoutSlice.actions

export const layoutReducer = layoutSlice.reducer
